module.exports = __webpack_public_path__ + "img/share.52def73.png";